import { useState, useEffect } from 'react'
import { recibirUserInfo } from '../servicios/mercadoPagoService.js'

const RTA_EXITOSA = 200

const cuentasVinculadasMP = new Map()

export const obtenerCuentaVinculadaMP = (empid) => {
  if (!cuentasVinculadasMP.has(empid)) {
    cuentasVinculadasMP.set(
      empid,
      recibirUserInfo({ empid })
        .then(({ data }) => ({
          tieneCuentaVinculadaMP: data?.code === RTA_EXITOSA && !!data?.body?.nickname,
          respuesta: data?.code === RTA_EXITOSA ? data.code : data
        }))
        .catch((error) => {
          cuentasVinculadasMP.delete(empid)
          return { tieneCuentaVinculadaMP: false, respuesta: error?.response?.status }
        })
    )
  }
  return cuentasVinculadasMP.get(empid)
}

export const useTieneCuentaMPVinculada = (empid) => {
  const [tieneCuentaVinculadaMP, setTieneCuentaVinculadaMP] = useState(false)
  const [respuesta, setRespuesta] = useState(null)
  const [cargado, setCargado] = useState(false)

  useEffect(() => {
    if (!empid) {
      setTieneCuentaVinculadaMP(false)
      setCargado(true)
      return
    }
    cuentasVinculadasMP.delete(empid)
    let cancelado = false
    obtenerCuentaVinculadaMP(empid).then((resultado) => {
      if (cancelado) return
      setTieneCuentaVinculadaMP(resultado.tieneCuentaVinculadaMP)
      setRespuesta(resultado.respuesta)
      setCargado(true)
    })
    return () => {
      cancelado = true
    }
  }, [empid])

  return { tieneCuentaVinculadaMP, respuesta, cargado }
}
